/* eslint-disable no-nested-ternary */
import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import isEmpty from "lodash/isEmpty";
import { connect } from "react-redux";
import moment from "moment";

import { IoDownload } from "react-icons/io5";

import { formatDate } from "../../helpers/date";
import Loader from "../common/Loader";

import View from "../styled/View";

import SupportTicketHeader from "./SupportTicketHeader";

const formatPhoneNumber = (str) => {
  const clean = `${str}`.replace(/\D/g, "");
  const match = clean.match(/^(\d{3})(\d{3})(\d{4})$/);
  return {
    value: clean,
    formatted: match ? `(${match[1]}) ${match[2]}-${match[3]}` : ""
  };
};
// removed "codes" as a prop because it was not being used (EBW)
const SupportTicketDisplay = ({ supportTicket, open, toggleShow }) => {
  const data = {};
  const details = supportTicket.request_nature_details;
  const formattedDetails = details ? details.replace(/\n/g, "<br/>") : details;
  const phoneNumber = formatPhoneNumber(supportTicket.requestor_phone_number);

  const getDifferenceBetweenDates = (start, end) => {
    if (!start || !end) {
      return "";
    }
    const startTime = moment(start);
    const endTime = moment(end);
    const duration = moment.duration(endTime.diff(startTime));
    const hours = parseInt(duration.asHours());
    const minutes = parseInt(duration.asMinutes()) % 60;

    // if duration is less than 1 minute, default to 1 minute
    if (hours === 0 && minutes === 0) {
      return "0 minutes";
    }
    const hourString = Math.abs(hours)
      ? `${Math.abs(hours)} ${Math.abs(hours) > 1 ? "hours" : "hour"}`
      : "";

    const minuteString = Math.abs(minutes)
      ? `${Math.abs(minutes)} ${Math.abs(minutes) > 1 ? "minutes" : "minute"}`
      : "";
    return `${hourString} ${
      hourString && minuteString ? "and" : ""
    } ${minuteString || ""}`;
  };

  if (!isEmpty(supportTicket)) {
    // project info
    data["Requestor Company"] =
      supportTicket.customer?.name || supportTicket.requestor_company_name;
    data["Requestor Name"] = supportTicket.requestor_full_name;
    data["Request Date"] = formatDate(
      supportTicket.created_on,
      "MM/dd/yyyy hh:mm a"
    );
    data["Requestor Email"] = supportTicket.requestor_email;
    data["Requestor Phone Number"] = supportTicket.requestor_phone_number;
    data["Requestor Secondary Email"] = supportTicket.requestor_secondary_email;

    data["Request Nature"] = supportTicket.request_nature;
    data.Location = supportTicket.location;
  }

  if (isEmpty(supportTicket)) {
    return <Loader loading />;
  }

  return (
    <>
      {toggleShow && (
        <SupportTicketHeader
          supportTicket={supportTicket}
          open={open}
          toggleShow={toggleShow}
        />
      )}
      {open && (
        <React.Fragment>
          {" "}
          <div
            className="project-metrics"
            style={{
              display: "grid",
              gridTemplateColumns: `repeat(4, 1fr)`
            }}
          >
            <div className="content-wrapper">
              <fieldset>
                <legend>SLA Tier</legend>
              </fieldset>
              <span>
                {supportTicket?.project?.contract?.tier?.label || "N/A"}
              </span>
            </div>
            <div className="content-wrapper">
              <fieldset>
                <legend>Assigned In</legend>
              </fieldset>
              <span>
                {supportTicket.assigned_to
                  ? getDifferenceBetweenDates(
                      supportTicket.created_on,
                      supportTicket.assigned_on
                    )
                  : "Not Yet Assigned"}
              </span>
            </div>
            <div className="content-wrapper">
              <fieldset>
                <legend>Resolved In</legend>
              </fieldset>
              <span>
                {supportTicket.resolutions &&
                supportTicket.resolutions[0]?.resolved_on
                  ? supportTicket.totalBillableHours?.formattedStringHours
                  : "Not Yet Resolved"}
              </span>
            </div>
            <div className="content-wrapper">
              <fieldset>
                <legend>Ticket Life</legend>
              </fieldset>
              <span>
                {supportTicket.resolutions &&
                supportTicket.resolutions[0]?.resolved_on &&
                supportTicket.timeInProcess
                  ? supportTicket.timeInProcess
                  : "Not Yet Resolved"}
              </span>
            </div>
          </div>
          <RequestorViewStyles>
            <div className="content-wrapper">
              <fieldset>
                <legend>Requestor Details</legend>
              </fieldset>
              <div className="data-container-single">
                {Object.keys(data)
                  .filter((key) => data[key])
                  .map((key, i) => (
                    <div key={i} className="data">
                      <label htmlFor="contract">{key}</label>
                      {key === "Requestor Phone Number" ? (
                        <a href={`tel:${phoneNumber.value}`}>
                          {supportTicket.requestor_phone_ext
                            ? `${phoneNumber.formatted} ext. ${supportTicket.requestor_phone_ext}`
                            : phoneNumber.formatted}
                        </a>
                      ) : [
                          "Requestor Email",
                          "Requestor Secondary Email"
                        ].includes(key) ? (
                        <a href={`mailto:${data[key]}`}>{data[key]}</a>
                      ) : (
                        <span id="contract">{data[key]}</span>
                      )}
                    </div>
                  ))}
              </div>
            </div>
            <div
              className="content-wrapper"
              style={{
                minHeight: "350px"
              }}
            >
              <fieldset>
                <legend>Request Details</legend>
              </fieldset>
              <div dangerouslySetInnerHTML={{ __html: formattedDetails }} />
              {supportTicket.internal_cc?.email && (
                <React.Fragment>
                  <fieldset>
                    <legend>CC Email</legend>
                  </fieldset>
                  <a href={`mailto: ${supportTicket.internal_cc.email}`}>
                    {supportTicket.internal_cc.email}
                  </a>
                </React.Fragment>
              )}
              {supportTicket.internal_note && (
                <React.Fragment>
                  <fieldset>
                    <legend>Internal Notes</legend>
                  </fieldset>
                  <p style={{ textAlign: "justify" }}>
                    {supportTicket.internal_note}
                  </p>
                </React.Fragment>
              )}
              <div style={{ position: "absolute", bottom: 20, right: 20 }}>
                {supportTicket.request_attachment_url && (
                  <a
                    href={supportTicket.request_attachment_url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button
                      className="btn btn-primary"
                      style={{ color: "WHITE" }}
                    >
                      <IoDownload />
                      <span>Attachment</span>
                    </button>
                  </a>
                )}
                {supportTicket.request_attachment_url_2 && (
                  <a
                    href={supportTicket.request_attachment_url_2}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ marginLeft: "1rem" }}
                  >
                    <button
                      className="btn btn-primary"
                      style={{ color: "WHITE" }}
                    >
                      <IoDownload />
                      <span>Attachment 2</span>
                    </button>
                  </a>
                )}
                {supportTicket.request_attachment_url_3 && (
                  <a
                    href={supportTicket.request_attachment_url_3}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ marginLeft: "1rem" }}
                  >
                    <button
                      className="btn btn-primary"
                      style={{ color: "WHITE" }}
                    >
                      <IoDownload />
                      <span>Attachment 3</span>
                    </button>
                  </a>
                )}
              </div>
            </div>
          </RequestorViewStyles>
        </React.Fragment>
      )}
    </>
  );
};

const RequestorViewStyles = styled(View)`
  display: grid;
  grid-template-columns: 1fr 2fr;
`;

SupportTicketDisplay.propTypes = {
  supportTicket: PropTypes.object,
  open: PropTypes.bool,
  toggleShow: PropTypes.func
};

const mapStatesToProps = (state) => ({
  codes: state.reducers.codes
});

export default connect(mapStatesToProps)(SupportTicketDisplay);
